import React, {useEffect} from "react";
import "./FaqView.scss";
import {Tabs} from "antd";
import {TabPosition} from "rc-tabs/lib/interface";
import {TabsType} from "antd/lib/tabs";
import {Translate, TranslateFunction} from "react-localize-redux";
import {useDispatch, useSelector} from "react-redux";
import {Dispatch} from "redux";
import StoreState from "../../interfaces/store/storeState";
import FaqList from "../../components/FaqList/FaqList";
import {
    clearFaqList, getFaqList, searchFaq, setActiveFaqType,
} from "../../store/actions/faq";
import {Faq} from "../../interfaces/store/actions/payload/faq";
import {FaqTypeAll} from "../../utils/constants";
import {selectTranslate} from "../../store/selectors/translate";

const {TabPane} = Tabs;

const FaqView: React.FC = (): React.ReactElement => {
    const translatePath: string = "pages.FaqView.FaqView";
    const dispatch: Dispatch = useDispatch();
    const translate: TranslateFunction = useSelector(selectTranslate);
    const isMobile: boolean = useSelector(({mobile}: StoreState) => mobile.isMobile);
    const list: Faq[] = useSelector(({faq}: StoreState) => faq.list);
    const activeFaqType: string = useSelector(({faq}: StoreState) => faq.activeFaqType);

    const tabPosition: TabPosition = isMobile ? "top" : "left";
    const tabType: TabsType = isMobile ? "line" : "card";

    useEffect(() => {
        dispatch(getFaqList());
    }, [dispatch]);

    useEffect(() => () => {
        dispatch(setActiveFaqType(FaqTypeAll));
        dispatch(clearFaqList());
    }, [dispatch]);

    /**
     * On tab change event, set store's current active faq type
     * @param {string} currentTabType
     */
    const onChangeHandler = (currentTabType: string): void => {
        dispatch(setActiveFaqType(currentTabType));
        dispatch(searchFaq(""));
    };

    /**
     * Generate tab panes for all faq question and for each category separately that exists
     * @return {React.ReactNode}
     */
    const getTabPanes = (): React.ReactNode => {
        const availableFaqTypes: string[] = [];

        if (list.length) {
            availableFaqTypes.push(FaqTypeAll);
            list.forEach((faq: Faq) => {
                const {Category}: Faq = faq;
                if (Category && !availableFaqTypes.includes(Category.trim())) {
                    availableFaqTypes.push(Category.trim());
                }
            });
        }

        return availableFaqTypes.map((availableFaqType: string) => {
            const tabKey: string = availableFaqType.replace(/\s/g, "-");
            return (
                <TabPane
                    tab={availableFaqType}
                    key={tabKey}
                >
                    {activeFaqType === tabKey && (
                        <FaqList isMobile={isMobile} key={tabKey}/>
                    )}
                </TabPane>
            );
        });
    };

    return (
        <div className="df-faqs-container">
            <Tabs
                tabPosition={tabPosition}
                type={tabType}
                onChange={onChangeHandler}
                moreIcon={(
                    <span aria-label={translate(`${translatePath}.moreTabs.text`) as string}>
                        <Translate id={`${translatePath}.moreTabsContent.text`}/>
                    </span>
                )}
            >
                {getTabPanes()}
            </Tabs>
        </div>
    );
};

export default FaqView;
